import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68b438a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["category-box me-2", {'router-link-exact-active': this.$route.params.game === _ctx.obj.params.game}])
  }, [
    _createVNode(_component_router_link, { to: _ctx.obj }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.itemImage(_ctx.image)
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}